"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addChangeContext = exports.CollectionDriver = void 0;
var core_1 = require("@stylable/core");
var CollectionDriver = /** @class */ (function () {
    function CollectionDriver(getStylesheet, resolveSymbol, updateFromAST) {
        this.getStylesheet = getStylesheet;
        this.resolveSymbol = resolveSymbol;
        this.updateFromAST = updateFromAST;
    }
    CollectionDriver.changeValue = function (contexts, value) {
        contexts.forEach(function (context) { return context.change(value); });
    };
    CollectionDriver.prototype.collect = function (sheetPath, selector) {
        var _this = this;
        var data = this.initialData();
        var sheet = this.getStylesheet(sheetPath);
        if (!sheet) {
            return data;
        }
        sheet.walkRules(function (rule) {
            if (!rule.selector.match(selectorRegExp(selector)) && !core_1.matchSelectorTarget(selector, rule.selector)) {
                return;
            }
            rule.walkDecls(function (decl) {
                // console.log(`router(${decl.prop})`);
                _this.router(decl, sheet, data);
            });
        });
        // console.log(declarations);
        return data;
    };
    CollectionDriver.prototype.initialData = function () {
        return {};
    };
    CollectionDriver.prototype.router = function (_decl, _sheet, _data) {
        //
    };
    return CollectionDriver;
}());
exports.CollectionDriver = CollectionDriver;
function selectorRegExp(selector) {
    return new RegExp("^" + selector + "$|^" + selector + "[:].*$");
}
function addChangeContext(declarations, decl, value, change) {
    if (declarations[value] === undefined) {
        declarations[value] = [];
    }
    declarations[value].push({ declaration: decl, change: change });
}
exports.addChangeContext = addChangeContext;
//# sourceMappingURL=stylable-collection.js.map